import datepopup from './datepopup'
datepopup.install = (Vue) => {
  Vue.component(datepopup.name, datepopup)
}

export default datepopup


// WEBPACK FOOTER //
// ./src/components/datepopup/index.js